import React from 'react';
import { Paper, Typography } from '@mui/material';

import { isFeaturePatternTruss } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';
import { Dialog } from '@paragon/popup-state';

import { setComponentDepth } from '../../store/actions/editComponentActions';
import { getActiveComponentDesign } from '../../store/selectors/getActiveComponentDesignSelector';
import { propertiesShouldBeViewOnly } from '../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../hooks';

const defaultResponse = (
  <Dialog title="Adjust Depth" variant="design" cancelText="Close" onCancel="close">
    <Paper>
      <Typography variant="body1">The depth of this component cannot be adjusted.</Typography>
    </Paper>
  </Dialog>
);

export function EditDepthDialog() {
  const dispatch = useAppDispatch();
  const isViewOnly = useAppSelector(propertiesShouldBeViewOnly);
  const componentDesign = useAppSelector(getActiveComponentDesign);

  if (isViewOnly || !componentDesign || !isFeaturePatternTruss(componentDesign.component)) return defaultResponse;

  const referenceLines = componentDesign.component.referenceLines;
  const horizontalMaxGuid = componentDesign.component.horizontalMaxGuid;
  if (!referenceLines || !horizontalMaxGuid) return defaultResponse;

  const horizontalMaxLine = referenceLines.find(({ guid }) => guid === horizontalMaxGuid);
  // Without a parallel horizontal max line, depth adjust won't work anyway
  if (!horizontalMaxLine || horizontalMaxLine.lineType !== 'Parallel') return defaultResponse;

  const depth = horizontalMaxLine.offset;

  return (
    <Dialog title="Adjust Depth" variant="design" cancelText="Close" onCancel="close">
      <DistanceField
        label="Depth"
        onSubmit={(value) => {
          dispatch(setComponentDepth(value, componentDesign.guid));
        }}
        value={depth}
        min={0}
      />
    </Dialog>
  );
}
